import React from 'react'
import { motion } from 'framer-motion';
import Navbar from '../../components/common/Navabar'
import serviceImage from "../../asserst/websiteImage/serviceImage.png"
import Footer from '../../components/common/Footer';
import contactFormImg from "../../asserst/websiteImage/contact-us.jpg"
import InquiryForm from '../../components/common/Homepage_Form';

const ContactUsPage = () => {
    return (
        <div>
            <div className="bg-white">
                <Navbar />
                <motion.section
                    className="relative h-[30vh] rounded-b-[30px] "
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                >

                    <img src={serviceImage} className="h-full w-full object-cover rounded-b-[30px]" alt="Main Bus" />
                    <div className="absolute inset-0 bg-[#0739564D] flex rounded-b-[30px] items-center justify-center">
                    </div>
                    <div className="absolute -bottom-24  flex-col md:w-[25rem] xsm:w-[15rem] md:h-[12rem] xsm:h-[8rem] rounded-xl shadow-lg border-blue-600 border-[2px] left-1/2 transform -translate-x-1/2  bg-white flex text-center items-center justify-center"
                        style={{ boxShadow: "10px 10px 30px 0px #0000001A" }}
                    >
                        <div className='w-full '>
                            <motion.h2
                                className="font-bold text-gray-800 mb-5 md:text-[50.8px] xsm:text-[2.5rem] w-[100%] leading-[47px]  underline-offset-[from-font] decoration-none"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                Contact Us
                            </motion.h2>
                            <motion.p
                                className="text-gray-500 font-poppins text-base w-[100%] font-normal leading-6  underline-offset-[from-font] decoration-none"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.4 }}
                            >
                                Home/Contact-Us
                            </motion.p>
                        </div>
                    </div>

                </motion.section>
            </div>
            <section className='w-full md:h-[700px] mt-28'>
                <div className='md:w-[80%] lg:w-[80%] xsm:w-[90%]  flex flex-col mx-auto'>
                    <div className=''>
                        <motion.h2
                            className="font-bold  text-gray-800 xsm:text-[1.3rem]   md:text-[1.8rem] lg:text-[2.0rem] md:w-[90%]  xsm:w-[100%] leading-[47px] text-left underline-offset-[from-font] decoration-none"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                        >
                            Feel Free to
                            <br />
                            Knock Us!
                        </motion.h2>
                        <motion.p
                            className="text-gray-500 font-poppins text-base md:w-[9 0%] xsm:w-[] font-normal leading-6 text-left underline-offset-[from-font] decoration-none"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                        >
                            At Qbus Rentals, we believe in fostering strong and open communication with our customers. Whether you're looking for a quick ride across town, planning a long-distance trip, or have questions about our services, we are here to assist you every step of the way. Your convenience, comfort, and satisfaction are at the heart of everything we do, and we encourage you to reach out with any inquiries, concerns, or feedback.
                        </motion.p>
                    </div>
                    <div className=" w-[100%] mx-auto  flex flex-col md:flex-row justify-center items-center lg:gap-10 md:gap-8 xsm:gap-5">
                        {/* Form Section */}
                        <div className="w-[90%] md:w-[50%] mx-auto flex justify-center items-center h-[500px] xsm:mt-20 md:mt-10">
                            <InquiryForm />
                        </div>

                        {/* Image Section */}
                        <div className="w-[90%] md:w-[50%] flex justify-center items-center">
                            <img
                                src={contactFormImg}
                                alt="Our Vision"
                                className="h-72 w-full object-center object-contain rounded-md"
                            />
                        </div>
                    </div>
                </div>


            </section>
            <div className='bg-[#0B0757] pb-10'>
                <Footer />
            </div>
        </div>
    )
}

export default ContactUsPage

